module.exports = __webpack_public_path__ + "static/media/RT.c60c2807.png";